export const ORDER = {
  DEFAULT: '주문유형',
  ALL: '전체',
  DELIVERY: '배달',
  PICK_UP: '픽업',
  RESERVE: '사전예약',
}

export const STATUS = {
  DEFAULT: '주문상태',
  ALL: '전체',
  COMPLETE: '완료',
  CANCEL: '취소',
  PROGRESS: '진행중',
}

export const REVIEW_SUMMARY = {}

export const CHART = {
  DATE: '날짜별',
  TIME: '시간별',
  MENU: '메뉴',
}

export const PAGE_URL = {
  ORDER_LIST: 'OrderList',
  ITEM_LIST: 'itemList',
  OPTION_LIST: 'optionList',
  STORE_LIST: 'storeList',
  MANAGE_LIST: 'manageStoreInfo',
  DELIVERY_LIST: 'storeDeliveryInfo',
  SETTLEMENT: 'settlements',
  VAT_REPORT: 'vatReport',
  STAT: 'totalOrder',
  REVIEW_LIST: 'reviewList',
  NOTICE_LIST: 'NoticeList',
  GUIDE: 'useguide',
  SIGN_IN: 'signin',
  FIND_ID: 'findid',
  RESET_PASSWORD: 'resetPassword',
  CHANGE_PASSWORD: 'changePassword',
}

export const PAGE_NAME = {
  ORDER: '주문관리',
  ITEM: '메뉴•옵션관리',
  STORE: '매장관리',
  SETTLEMENT: '정산내역',
  VAT_REPORT: '해피오더 부가세 신고자료',
  STAT: '통계',
  REVIEW: '리뷰관리',
  NOTICE: '공지사항',
  GUIDE: '', //이용가이드  FAQ
  ETC: '해피오더 사장님',
  SIGN_IN: '',
}

// 탭
export const TAB_URL = {
  // 매장관리
  STORE_LIST_SHOP: 'shop',
  STORE_LIST_MANAGE: 'manage',
  STORE_LIST_DELIVERY: 'delivery',

  // 주문관리
  TODAY_ORDER_LIST: 'todayOrderList',
  SELECT_ORDER_LIST: 'selectOrderList',
}

// API 응답
// ref) SPCAgentServer - CommonResponseEnum.java
export const API_RESPONSE = {
  // 성공
  SUCCESS: '0000',

  // 실패
  BAD_REQUEST: '400',
  FORBIDDEN: '403',
  DUPLICATE: '499',
  INTERNAL_SERVER_ERROR: '500',
  GATEWAY_TIMEOUT: '504',
  FAILURE: '9999',

  // 데이터 없는 경우
  NOT_DATA: '1000',

  // 사용자
  // 상수 이름 변경 필요
  MEMBER_9992: '9992', // 없는 사용자
  MEMBER_9993: '9993', // 해지 사용자
  MEMBER_9994: '9994', // 등록 연락처 정보 없음
  MEMBER_9995: '9995', // 비밀번호 오류 횟수 초과
  MEMBER_9996: '9996', // 장기 미접속 계정잠금 상태
  MEMBER_9998: '9998', // 만료 비밀번호
  MEMBER_9999: '9999', // 아이디 또는 비밀번호 불일치

  // 통계
  STAT_EMPTY: '1003',

  // 나머지 작업 진행하면서 추가
}

// 약관
export const USE_GUIDE = {
  PRIVACY: '개인정보처리방침',
  SERVICE: '서비스이용약관',
}

// 플랫폼
// S9_Code 참고
// 202 사장님WEB
export const PLATFORM = {
  CEO_WEB: '202',
}

// 액션 코드
// S9_Code 참고
// 1201~1206
// 현재 Agent 액션코드로 메모에 정의 되어 있으나 통합 액션코드로 수정 예정
export const ACTION = {
  ENTER: '1201', // 진입
  READ: '1202', // 읽음
  MODIFY: '1203', // 수정
  INSERT: '1204', // 입력
  DELETE: '1205', // 삭제
  EXIT: '1206', // 진출
}

// 아이디
// 사장님웹: 2(에이전트: 1)
export const ID = {
  WEB: '2',
}
